<template>
  <div class="cover-singer-item">
    <AudioPlayer
      ref="refPlayer"
      :url="getObjectStorageFullUrl(props.item?.url)"
      :duration="renderData.duration"
      @syncDuration="syncDuration"
      @syncPlayState="syncPlayState"
      @syncLoadingState="syncLoadingState"
      @syncProgress="syncProgress"
      v-model:isGenerating="renderData.isGenerating"
    >
      <div class="cover-singer-item-add flex-center pointer">
        <LazyLoadImg
          :src="
            props.item?.background_url
              ? getObjectStorageFullUrl(props.item?.background_url)
              : defaultCover
          "
        ></LazyLoadImg>
        <div class="cover-singer-item-playButton flex-center" @click="doTogglePlay">
          <i
            class="block"
            :class="{
              'isplay-false': !renderData.isplay,
              'isplay-true': renderData.isplay,
            }"
          ></i>
        </div>
      </div>

      <div class="cover-singer-item-label flex pointer" @click="doSelected">
        <i
          class="block"
          :class="{
            selected:
              coverVoiceDataStore.curUseReferMusic?.id === props.item?.id,
          }"
        ></i>
        <span class="block olh">custom</span>
      </div>
    </AudioPlayer>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance
} from "vue";
import defaultCover from "@/assets/img/default-cover-3x.png";

import { useRouter, useRoute } from "vue-router";

import AudioPlayer from "@/components/media/audioPlayer/AudioPlayer.vue";
import { getObjectStorageFullUrl } from "@/lib/objectStorage/objectStorage.js";
import mediaUtils from "@/components/media/utils/utils.js";
import { $$t } from "@/i18n/i18n.js";
import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import useCoverVoiceDataStore from "@/store/editor/coverVoiceDataStore.js";
import LazyLoadImg from "@/components/media/lazyLoad/LazyLoadImg.vue"

const coverVoiceDataStore = useCoverVoiceDataStore();
const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);

const Router = useRouter();
const route = useRoute();

const appContext = getCurrentInstance()?.appContext;

const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
});
const emits = defineEmits([]);

const refPlayer = ref(null);

const renderData = reactive({
  isCurPlay: false,
  curUseReferMusic: null,
  duration: (props.item?.duration_milliseconds ?? 0) / 1000,
  isplay: false,
  buffer: false,
  progress: 0,
});

const syncDuration = (duration) => {
  renderData.duration = duration;
};

const syncPlayState = (playState) => {
  renderData.isplay = playState;
};
const syncLoadingState = (loadingState) => {
  renderData.buffer = loadingState;
};
const syncProgress = (progress) => {
  renderData.progress = progress;
};

const doTogglePlay = () => {
  refPlayer.value?.changeOp();
};

const doSelected = () => {
  coverVoiceDataStore.setReferMusic(props.item);
};

const changeUrlListenerListener = () => {
  renderData.isCurPlay =
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.currentUrl ==
    `${getObjectStorageFullUrl(props.item?.url)}${props.audioUrlSuffix}&id=${
      props.item?.id
    }`;
};
onMounted(() => {
  renderData.duration = (props.item?.duration_milliseconds || 0) / 1000;
  appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.registGlobalListener(
    "curPlayUrlChange",
    changeUrlListenerListener
  );
  // console.log("onMounted", props.item);
});

onUnmounted(() => {
  appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.releaseGlobalListener(
    "curPlayUrlChange",
    changeUrlListenerListener
  );
  // console.log("onMounted", props.item);
});
</script>
<style lang="scss">
.cover-singer-item {
  width: var(--cover-singer-item-width);
  .cover-singer-item-add {
    height: var(--cover-singer-item-width);
    border-radius: 50%;
    position: relative;

    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;
      border: none;
    }
    .cover-singer-item-playButton {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0px;
      width: calc(var(--cover-singer-item-width) - 22px);
      height: 32px;
      border-radius: 70px;
      background: rgba(255, 255, 255, 0.3);
      backdrop-filter: blur(50px);
      &:hover {
        background: rgba(255, 255, 255, 0.4);
      }
      i {
        height: 16px;
        width: 16px;
      }
      .isplay-false {
        background: url("@/assets/img/play-light-ico.png");
        background-size: 100% 100%;
      }
      .isplay-true {
        background: url("@/assets/img/pause-light-ico.png");
        background-size: 100% 100%;
      }
    }
  }
  .cover-singer-item-label {
    font-family: HarmonyOS Sans SC;
    font-size: 14px;
    color: #ffffff;
    line-height: 20px;
    margin: 12px auto 0;
    justify-content: center;
    i {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      border: 2px solid rgba(255, 255, 255, 0.5);
      &.selected {
        background: url("@/assets/img/editor/singer-selected.png");
        background-size: 100% 100%;
        border: none;
      }
    }
    span {
      font-family: HarmonyOS Sans SC;
      font-size: 14px;
      line-height: 20px;
      color: #ffffff;
      flex: 0 1 1;
      margin: 0 0 0 6px;
    }
    &:hover {
      i {
        border-color: rgba(148, 173, 255, 1);
      }
    }
  }
}
</style>
